// Định nghĩa màu sắc chung cho toàn bộ ứng dụng
export const COLORS = {
  // Màu chủ đạo của ứng dụng
  primary: 'var(--primary-color)', // màu chính của Vissoft Tracker - xanh
  secondary: 'var(--accent-color)', // màu phụ - đỏ
  strava: 'var(--strava-orange)', // màu chính Strava - cam
  
  // Màu nền
  background: {
    main: 'var(--background-main)', // nền chính
    light: 'var(--background-card)', // nền sáng hơn
    dark: 'var(--background-dark)', // nền tối hơn
    darker: 'var(--background-darker)', // nền tối nhất
    input: 'var(--background-input)', // nền cho input
    hover: 'var(--background-hover)', // nền khi hover
  },
  
  // Màu text
  text: {
    light: 'var(--text-primary)',
    medium: 'var(--text-secondary)',
    dark: 'var(--text-muted)',
  },
  
  // Màu trạng thái
  status: {
    success: 'var(--status-success)', // xanh lá
    error: 'var(--status-error)', // đỏ
    warning: 'var(--status-warning)', // vàng
    info: 'var(--status-info)', // xanh dương
    disabled: '#666', // xám
  },
  
  // Màu viền
  border: 'var(--border-color)',
  
  // Radius
  borderRadius: {
    sm: 'var(--border-radius-sm)',
    md: 'var(--border-radius-md)',
    lg: 'var(--border-radius-lg)',
  },
  
  // Shadow
  shadow: {
    sm: 'var(--shadow-sm)',
    md: 'var(--shadow-md)',
    lg: 'var(--shadow-lg)',
  },
  
  // Loại hoạt động
  RUNNING: '#FF5722',
  CYCLING: '#2196F3',
  SWIMMING: '#00BCD4',
  OTHER: '#9E9E9E',
};

export default COLORS; 